"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var DropdownButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/DropdownButton"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var ordered_1 = require("utils/selectors/ordered");
var TeamDropdown = function (_a) {
    var _b = _a.input, onChange = _b.onChange, value = _b.value, disabled = _b.disabled;
    var companyTeams = (0, react_redux_1.useSelector)(ordered_1.selectCompanyTeams);
    var _c = __read(react_1.default.useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var handleClick = function (event) { return setAnchorEl(anchorEl ? null : event.currentTarget); };
    // const [resendInvite, isResending] = useCall('invitations-resendInvitation', invitation.id);
    var handleOnClose = function () { return setAnchorEl(null); };
    var selectedCompanyTeam = react_1.default.useMemo(function () { return value && (companyTeams === null || companyTeams === void 0 ? void 0 : companyTeams.find(function (cT) { return cT.id === value; })); }, [value, companyTeams]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DropdownButton_1.default, __assign({ onClick: handleClick, isOpen: !!anchorEl, disabled: (0, react_redux_firebase_1.isEmpty)(companyTeams) }, { children: (selectedCompanyTeam === null || selectedCompanyTeam === void 0 ? void 0 : selectedCompanyTeam.name) || 'Choose team (optional)' })), (0, jsx_runtime_1.jsx)(DropdownMenu_1.default, __assign({ anchorEl: anchorEl, open: !!anchorEl, onClose: handleOnClose }, { children: companyTeams === null || companyTeams === void 0 ? void 0 : companyTeams.map(function (team, index) { return ((0, jsx_runtime_1.jsx)(DropdownOption_1.default, { selected: team.id === value, title: team.name, onClick: function () {
                        onChange === null || onChange === void 0 ? void 0 : onChange(team.id);
                        handleOnClose();
                    }, disabled: disabled, autoFocus: index === 0 }, team.id)); }) }))] }));
};
exports.default = TeamDropdown;
